import { render } from "./SettingHistory.vue?vue&type=template&id=6c3006a5"
import script from "./SettingHistory.vue?vue&type=script&lang=js"
export * from "./SettingHistory.vue?vue&type=script&lang=js"

import "./SettingHistory.vue?vue&type=style&index=0&id=6c3006a5&lang=css"

import exportComponent from "/mnt/d/Projects/santanu-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__